import React from 'react';
import ReportDateSelector, { DateRangeOption } from './ReportDateSelector';

interface ReportsHeaderProps {
  range: DateRangeOption;
  setRange: (r: DateRangeOption) => void;
  onBuildReport: () => void;
  onExport: () => void;
  isExporting: boolean;
}

const ReportsHeader: React.FC<ReportsHeaderProps> = ({ 
  range, setRange, onBuildReport, onExport, isExporting 
}) => {
  return (
    <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 bg-white dark:bg-slate-800 p-8 rounded-[2.5rem] border border-slate-200 dark:border-slate-700 shadow-sm">
      <div>
        <h1 className="text-3xl font-black text-slate-900 dark:text-white tracking-tight">Reports & Analytics</h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Analyzing subscription health and unit economics.</p>
      </div>
      
      <div className="flex flex-wrap items-center gap-4 w-full lg:w-auto">
        <div className="flex flex-col gap-1.5">
          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Dashboard Period</label>
          <ReportDateSelector value={range} onChange={setRange} />
        </div>
        <div className="h-10 w-px bg-slate-100 dark:bg-slate-700 hidden lg:block mx-2"></div>
        <div className="flex gap-2 ml-auto">
          <button 
            onClick={onBuildReport}
            className="flex items-center gap-2 px-6 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-black uppercase tracking-widest hover:bg-indigo-700 shadow-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Build
          </button>
          <button 
            onClick={onExport}
            disabled={isExporting}
            className="flex items-center gap-2 px-5 py-2.5 bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-600 transition-all disabled:opacity-50"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
            Export
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportsHeader;